window.mcb.forms.field = function (
  formId,
  prefills,
  settings
) {
  const _logger = window.mcb.utilities.createLogger("forms.field");

  const fireFieldModifiedEvents = function (control, fireUpdateEvents = false, allowValueFormatting = false) {
    _logger.trace('Firing field modified events', this, control, fireUpdateEvents);
    formElement.dispatchEvent(new CustomEvent('MCB.Events.WebForms.ControlChange.Standard', {
      'detail': {
        origin: _thisField,
        control
      }
    }));

    if (fireUpdateEvents) {
      _logger.trace('Firing field updated events', this);
      const value = internalGetValue(allowValueFormatting);
      // getValue() will apply Validation and update the UI per the results
      formElement.dispatchEvent(new CustomEvent('MCB.Events.WebForms.FieldUpdated.Standard', {
        'detail': {
          origin: _thisField,
          value
        }
      }));
    }
  };

  /* init */
  const _thisField = this;
  {
    _thisField.settings = settings;
    _thisField.events = settings.events ?? {};
    _thisField.alias = _thisField.settings.name;
    _thisField.logDescriptor = '"' + (_thisField.settings.title ?? _thisField.alias) + '"';
    _thisField.formId = formId;
    _thisField.fieldGroupId = formId + "_" + _thisField.alias;
    _thisField.fieldValueControlId = settings.fieldValueControlId ?? _thisField.fieldGroupId + "_cntrl";
    _thisField.fieldValueControl = null;
    _thisField.eventsAreBound = false;
    _thisField.conditionReferenceValues = {};
    _thisField.applyValidationDuringInput = !window.mcb.utilities.browser.getUrlBooleanParameter('forms-validation-subtle');
    _thisField.prefills = prefills[_thisField.settings.name] ?? [];

    if (_thisField.prefills.length > 0) {
      _thisField.settings.defaultValue = _thisField.prefills.join('\n');
    }
  }

  let fieldGroup;
  const formElement = document.getElementById(_thisField.formId);

  const fieldTypes = {
    choice: 'Choice',
    multiChoice: 'MultiChoice',
    files: 'Attachments',
    information: 'Paragraph',
    date: 'DateTime',
    text: 'Text',
    note: 'Note',
    hidden: 'Hidden'
  }

  const loadExtension = function () {
    for (const [key, value] of Object.entries(fieldTypes)) {
      if (value === _thisField.settings.type && window.mcb.forms.fields.extensions[key] !== undefined) {
        return new window.mcb.forms.fields.extensions[key](_thisField, {
          fireFieldModifiedEvents,
          validateEvent
        });
      }
    }

    return null;
  };

  const internalGetValue = function (allowValueFormatting = false) {
    if (_extension !== null) {
      _logger.trace(_thisField.logDescriptor + ' (' + allowValueFormatting + '):: getValue calling typed function');
      const value = _extension.getValue(allowValueFormatting);
      if (value === null) {
        _logger.warn(_thisField.logDescriptor + ' is NOT valid!');
      }
      else if (value === undefined) {
        _logger.trace(_thisField.logDescriptor + ' is hidden, so no value is returned');
      }

      return value;
    }

    throw new Error("No extension found for field type: " + _thisField.settings.type);
  };

  const getValue = function (allowValueFormatting = false, extendFunction = null, extendedPostProcessorFunction = null) {
    let value = null;
    if (extendFunction !== null && typeof extendFunction === "function") {
      _logger.trace(_thisField.logDescriptor + ' (' + allowValueFormatting + '):: getValue calling custom function', extendFunction);
      value = extendFunction(_thisField, disableField) ?? null;
    }

    if (value === null) {
      value = internalGetValue(allowValueFormatting);
    }

    let extended_value;
    if (extendedPostProcessorFunction !== null && typeof extendedPostProcessorFunction === "function") {
      _logger.trace(_thisField.logDescriptor + ' (' + allowValueFormatting + '):: getValue calling post processor function', extendedPostProcessorFunction);
      extended_value = extendedPostProcessorFunction(_thisField, value) ?? null;
      if (extended_value !== null) {
        value = extended_value;
      }
    }

    return value;
  };

  const validateEvent = function (event, field, control) {
    _logger.trace(event.type + ' event fired', field.settings.name, event.target);
    if (control !== event.target) {
      throw new Error(event.type + " event fired on wrong target", control, event.target);
    }
  };

  const _extension = loadExtension();

  return _ = {
    render: function (target, bindEvents = true, enrichFieldFunction = null) {
      if (_thisField.settings.type === fieldTypes.hidden || _thisField.settings.type === fieldTypes.information) {
        return _extension.render(target);
      }

      fieldGroup = document.createElement('div');
      fieldGroup.id = _thisField.fieldGroupId;
      fieldGroup.classList.add(window.mcb.forms.constants.fields.classBase);
      fieldGroup.classList.add(window.mcb.forms.constants.fields.classBase + _thisField.settings.type.toLowerCase());
      target.append(fieldGroup);

      _logger.trace('add field', _thisField.settings.type, _thisField.settings);

      let validatedControl = null;
      if (_extension !== null) {
        validatedControl = _extension.render(fieldGroup);
      }

      if (validatedControl !== null) {
        if (_thisField.settings.required) {
          fieldGroup.classList.add(window.mcb.forms.constants.fields.requiredClass);
        }

        if (_thisField.settings.condition !== null) {
          const rules = _thisField.settings.condition.rules;
          _thisField.settings.conditionTriggers = rules.map(r => r.reference);
          for (let rule of rules) {
            fieldGroup.classList.add(window.mcb.forms.constants.conditionals.dependance + window.mcb.utilities.strings.toKebab(rule.reference));
            fieldGroup.classList.add(window.mcb.forms.constants.conditionals.type + window.mcb.utilities.strings.toKebab(_thisField.settings.condition.actionType));
          }

          formElement.addEventListener('MCB.Events.WebForms.FieldUpdated.Standard', function (e) {
            if (_thisField.settings.conditionTriggers.indexOf(e.detail.origin.alias) >= 0) {
              _logger.trace('evaluateCondition for field', _thisField);
              window.mcb.forms.helpers.evaluateCondition(_thisField, fieldGroup, _thisField.settings.condition, e.detail.origin, e.detail.value);
            }
          }, false);
        }

        if (
          _thisField.settings.title !== null &&
          _thisField.settings.title !== ""
        ) {
          fieldGroup.dataset.fieldTitle = _thisField.settings.title;

          if (_thisField.settings.showTitle !== false) {
            const label = document.createElement('label');
            fieldGroup.append(label);
            label.setAttribute('for', _thisField.fieldValueControlId);
            label.classList.add(window.mcb.forms.constants.fields.labelClass);
            label.append(_thisField.settings.title)

            if (_thisField.settings.required) {
              const req = document.createElement('span');
              label.append(req);
              req.classList.add(window.mcb.forms.constants.fields.requiredMarkClass);
            }
          }
        }

        if (_thisField.settings.description !== null) {
          description = document.createElement('div');
          description.classList.add(window.mcb.forms.constants.fields.descriptionClass);
          description.innerHTML = _thisField.settings.description;
          fieldGroup.append(description);
        }

        fieldGroup.append(validatedControl);

        if (typeof _extension.postRender === "function") {
          _logger.trace(_thisField.logDescriptor + ':: postRender called');
          _extension.postRender();
        }
      }

      if (enrichFieldFunction != null && typeof enrichFieldFunction === "function") {
        enrichFieldFunction(_thisField, jQuery(fieldGroup));
      }

      if (typeof _thisField.events.onRendered === "function") {
        _thisField.events.onRendered(_thisField, target, fieldGroup, validatedControl);
      }

      if (window.mcb.forms.debug) {
        let dbg = document.createElement('details');
        fieldGroup.append(dbg);
        dbg.innerHTML = '<summary>JS Obj:</summary><pre><code>' + JSON.stringify(_thisField.settings, null, 2) + '</code></pre>';
      }
    },
    onRendered: function () {
      if (_extension !== null && typeof _extension.onRendered === "function") {
        _extension.onRendered();
      }
    },
    getValue: function (extendFunction = null, extendedPostProcessorFunction = null) {
      return getValue(true, extendFunction, extendedPostProcessorFunction);
    },
    setValue: function (value, extendFunction) {
      let isSet = false;
      if (typeof extendFunction === "function") {
        _logger.trace(_thisField.logDescriptor + ' (' + value + '):: setValue calling custom function', extendFunction);
        isSet = extendFunction(_thisField, value);
      }

      if (!isSet) {
        if (_extension !== null) {
          _logger.trace(_thisField.logDescriptor + ' (' + value + '):: setValue calling typed function');
          isSet = _extension.setValue(value);
        }
        else {
          _logger.error('NotImplementet:', _thisField.settings.type, value);
        }
      }

      if (isSet !== true) {
        _logger.error('FailedToSet:', _thisField.alias, _thisField.settings.type, value);
      }

      return isSet;
    },
    settings: _thisField.settings,
    fieldGroupId: _thisField.fieldGroupId
  };
};
